import { useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { ROUTES } from 'src/routes';
import { usePerformanceActions } from 'src/store';

export const useCancelPerformanceWaitRequests = () => {
  const location = useLocation();
  const performanceActions = usePerformanceActions();

  useEffect(() => {
    if (!location.pathname.startsWith(ROUTES.PERFORMANCE)) {
      performanceActions.cancelWaitRequests();
    }
  }, [performanceActions, location]);
};
